export const getBrowserInfo = () => {
  const platformDetail =
    window.navigator?.userAgentData?.platform || window.navigator?.platform || 'unknown'

  const osVersion = window.navigator?.userAgent || window.navigator?.appVersion || 'unknown'

  const userAgent = window.navigator?.userAgent || 'unknown'

  return {
    platformDetail,
    osVersion,
    userAgent
  }
}
